import { useURequestRaw } from '@newageerp/v3.bundles.hooks-bundle'
import React, { useEffect } from 'react'
import { TabContainer } from '@newageerp/v3.bundles.layout-bundle';
import Disputes from './Components/Disputes/Disputes';
import EarlyFraudWarning from './Components/Disputes/EarlyFraudWarning';


export default function DashboardEarlyFraudWarning() {
  const [doReq, doReqParams] = useURequestRaw<any>("/app/plugins/StripeEarlyFraudWarning/reports");


  const loadData = () => {
    doReq({});
  }

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className='space-y-2'>
      <TabContainer
        items={[
          {
            content: <Disputes />,
            tab: {
              children: 'Disputes'
            }
          },
          {
            content: <EarlyFraudWarning />,
            tab: {
              children: 'Early fraud warnings'
            }
          }
        ]}
      />
    </div>
  )
}
